var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _image, _image2, _image3, _image4, _image5, _image6, _image7, _image8, _image9, _image10, _image11, _image12, _image13, _image14, _image15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlasvordachPfosten(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    space: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Glasvordach mit Pfosten"
  }, /*#__PURE__*/React.createElement("g", {
    id: "T\\xFCr",
    transform: "matrix(1.02241,0,0,0.978423,114.393,-6.14401)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.22269e-18,1.30381,-1.45151,-3.67188e-18,462.458,462.225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-89.735,118.699L120.636,118.49L120.636,89.648L-91.794,89.648L-89.735,118.699Z",
    style: {
      fill: "rgb(179,178,178)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.44939,-6.92115e-18,5.98671e-18,-1.29862,39.7616,313.178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-235.891L173.271,-235.891L172.797,-24.201L-0,11.099L0,-235.891Z",
    style: {
      fill: "rgb(112,111,111)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.25164,-1.45151,0,210.757,197.779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.618,117.805L81.635,117.805L117.804,-54.75L115.659,-83.759L68.618,117.805Z",
    style: {
      fill: "rgb(135,135,135)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Glasvordach mit Pfosten",
    transform: "matrix(1.31815,0,0,1.31815,15.6503,-36.8735)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(519.601,116.466,116.241,-520.608,26.9724,140.162)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00139046,0.000311061,0.000310459,-0.00138777,-0.117108,0.189297)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 42,
    y: 159,
    width: "703px",
    height: "131px"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.39656,0.396373,-0.395606,1.39926,280.565,111.378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.635,28.126L203.041,28.126L202.439,26.003L-4.19,26.167L-3.635,28.126Z",
    style: {
      fill: "rgb(141,187,212)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.45432,-1.45151,0,132.114,37.7604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.111,76.86L93.317,76.86L76.69,-91.111L74.654,-91.111L91.111,76.86Z",
    style: {
      fill: "rgb(65,138,169)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1.45432,-1.45151,0,445.375,136.461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.144,65.153L76.351,65.153L65.152,-74.144L62.946,-74.144L74.144,65.153Z",
    style: {
      fill: "rgb(177,199,209)",
      fillRule: "nonzero"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(16.0121,-16.0431,-16.0121,-16.0431,51.1091,214.417)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.876,0.477C0.729,0.608 0.468,0.561 0.26,0.354C0.022,0.115 -0.07,-0.238 0.068,-0.438C0.076,-0.461 0.099,-0.484 0.137,-0.523C0.284,-0.669 0.522,-0.584 0.729,-0.377C0.96,-0.146 1.099,0.238 0.929,0.423L0.876,0.477Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0236896,-0.0236896,-0.0236438,-0.0236438,3.844,7.7774)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 83.228,
    y: 218.63,
    width: "25.319px",
    height: "36.751px",
    transform: "matrix(0.973807,0,0,0.993278,0,0)"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.6864,-15.7171,-15.6867,-15.7168,52.9229,215.142)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.262,0.395C0.019,0.152 -0.075,-0.209 0.066,-0.414C0.207,-0.618 0.506,-0.586 0.749,-0.343C0.985,-0.107 1.071,0.261 0.945,0.466C0.934,0.482 0.922,0.496 0.909,0.509C0.762,0.656 0.486,0.618 0.262,0.395Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0241811,-0.0241815,-0.0241347,-0.0241343,3.8891,8.01967)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image5",
    x: 84.895,
    y: 218.829,
    width: "25.319px",
    height: "36.746px",
    transform: "matrix(0.973807,0,0,0.993124,0,0)"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.61598,9.18202,9.16426,-1.61912,92.3636,174.928)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.011,-1.173C-0.004,-1.413 0.029,-1.526 0.108,-1.54L0.186,-1.554C0.226,-1.48 0.353,-1.368 0.491,-1.043C0.767,-0.393 0.994,0.588 1.011,1.149C1.022,1.363 1.01,1.445 0.998,1.528L0.92,1.542C0.841,1.556 0.7,1.365 0.532,1.019C0.341,0.57 0.174,-0.037 0.083,-0.554C0.042,-0.786 0.016,-1 0.011,-1.173Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0141573,0.0802861,0.0801308,-0.0141299,-17.4672,-8.29416)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image7",
    x: 119.16,
    y: 218.942,
    width: "38.957px",
    height: "8.053px",
    transform: "matrix(0.998886,0,0,0.894738,0,0)"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.26075,-7.16431,-7.15045,-1.2632,92.5361,184.424)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.648,1.674C0.561,1.969 0.438,2.085 0.371,2.073C0.237,2.05 -0.083,1.132 0.005,0.045C0.093,-1.041 0.677,-2.006 0.743,-1.994C0.844,-1.977 0.936,-1.719 0.982,-1.195C1.014,-0.571 0.949,0.233 0.833,0.896C0.78,1.194 0.717,1.463 0.648,1.674Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0181428,-0.102898,-0.102699,-0.0181077,18.6821,17.8957)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image9",
    x: 118.83,
    y: 209.636,
    width: "38.958px",
    height: "9.391px",
    transform: "matrix(0.99892,0,0,0.939103,0,0)"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.965511,-6.47182,-6.4593,0.967382,75.987,207.085)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.005,2.331C1.022,2.444 0.857,2.62 0.634,2.654C0.373,2.693 0.127,2.577 0.061,2.396L0.05,2.322C0.045,2.285 0.038,-2.099 0.038,-2.099C0.019,-2.477 0.269,-2.591 0.53,-2.63C0.749,-2.701 0.952,-2.617 0.974,-2.468C0.974,-2.468 0.988,2.22 1.005,2.331Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0171722,-0.114882,-0.11466,0.017139,29.0596,9.25838)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image11",
    x: 94.08,
    y: 224.874,
    width: "45.183px",
    height: "13.986px",
    transform: "matrix(0.982249,0,0,0.998968,0,0)"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.99516,0.843943,0.842311,-6.00677,87.8421,193.413)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.01,1.757L0.036,-0.906C0.115,-1.47 0.741,-1.834 0.85,-1.737C0.995,-1.593 1.018,-1.467 1.001,-1.346L1.003,1.858C1.037,1.904 0.785,1.951 0.502,1.912C0.425,1.911 0.355,1.906 0.292,1.898C0.122,1.874 0.011,1.82 -0.01,1.757Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.124093,0.0174348,0.0174011,-0.123853,-20.1054,24.7174)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image13",
    x: 133.778,
    y: 206.993,
    width: "10.748px",
    height: "29.475px",
    transform: "matrix(0.977098,0,0,0.982513,0,0)"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(13.0461,-13.072,-13.0467,-13.0714,304.213,264.518)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.879,0.46C0.747,0.593 0.483,0.536 0.266,0.319C0.02,0.073 -0.065,-0.276 0.058,-0.455L0.134,-0.531C0.275,-0.672 0.492,-0.568 0.709,-0.351C0.936,-0.125 1.096,0.243 0.926,0.413L0.879,0.46Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.029074,-0.0290753,-0.0290191,-0.0290177,-3.06545,21.1619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image15",
    x: 434.156,
    y: 289.456,
    width: "19.151px",
    height: "29.923px",
    transform: "matrix(0.957569,0,0,0.997443,0,0)"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12.6531,-12.6779,-12.6534,-12.6776,305.751,264.9)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.257,0.375C0.004,0.122 -0.083,-0.238 0.043,-0.423C0.18,-0.617 0.481,-0.569 0.725,-0.325C0.958,-0.092 1.075,0.259 0.939,0.473C0.929,0.487 0.918,0.5 0.907,0.511C0.766,0.652 0.491,0.609 0.257,0.375Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0299778,-0.0299785,-0.0299205,-0.0299198,-3.20666,21.8953)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image17",
    x: 427.869,
    y: 296.849,
    width: "19.478px",
    height: "30.139px",
    transform: "matrix(0.973914,0,0,0.972232,0,0)"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0592558,5.31243,5.30216,-0.0593706,339.822,233.562)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.003,-1.737C0.047,-1.924 0.093,-2.017 0.186,-2.018L0.325,-2.019C0.373,-1.881 0.515,-1.65 0.66,-1.094C0.949,-0.169 1.01,1.085 0.878,1.69C0.88,1.876 0.834,1.969 0.835,2.016L0.741,2.017C0.602,2.018 0.413,1.695 0.267,1.093C0.067,0.454 -0.044,-0.275 -0.052,-0.926C-0.055,-1.217 -0.038,-1.493 0.003,-1.737Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00159885,0.143063,0.142787,-0.00159575,-39.4358,-65.8897)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image19",
    x: 461.573,
    y: 277.262,
    width: "28.241px",
    height: "6.834px",
    transform: "matrix(0.973839,0,0,0.976353,0,0)"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.863716,-4.90791,-4.89842,-0.865389,339.434,239.199)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.636,1.913C0.553,2.1 0.487,2.189 0.39,2.171C0.252,2.097 -0.081,1.133 0.019,-0.005C0.168,-1.135 0.601,-2.165 0.699,-2.148C0.845,-2.122 0.931,-1.755 0.966,-1.095C1.014,-0.406 0.987,0.454 0.869,1.124C0.812,1.443 0.736,1.72 0.636,1.913Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0264849,-0.150204,-0.149914,-0.0264336,29.4756,76.9158)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image21",
    x: 461.573,
    y: 278.519,
    width: "28.241px",
    height: "6.824px",
    transform: "matrix(0.973839,0,0,0.974892,0,0)"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.808988,-5.42629,-5.4158,0.810556,325.974,258.858)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.991,2.361C1.004,2.45 0.846,2.61 0.624,2.643C0.357,2.683 0.07,2.589 0.044,2.411L0.031,2.323C0.024,2.278 0.008,-2.085 0.008,-2.085C-0.001,-2.448 0.202,-2.614 0.514,-2.66C0.787,-2.656 0.985,-2.549 1.005,-2.416C1.005,-2.416 1.022,2.265 0.991,2.361Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0204677,-0.137022,-0.136757,0.0204281,50.7355,54.8032)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image23",
    x: 426.04,
    y: 318.341,
    width: "37.978px",
    height: "12.029px",
    transform: "matrix(0.999434,0,0,0.92534,0,0)"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.02492,0.707505,0.706137,-5.03466,335.625,247.36)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.023,1.783L0.012,-0.908C0.093,-1.485 0.73,-1.836 0.813,-1.727C0.944,-1.61 0.972,-1.459 0.958,-1.363L0.951,1.821C0.986,1.924 0.787,1.945 0.492,1.953C0.252,1.919 -0.037,1.878 -0.023,1.783Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.148052,0.0208053,0.0207651,-0.147766,-73.8206,33.2015)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image25",
    x: 466.901,
    y: 278.83,
    width: "8.815px",
    height: "24.808px",
    transform: "matrix(0.979405,0,0,0.992302,0,0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-3e-07,5.9793,5.96773,3e-07,289.238,161.664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.006,-1.733C0.035,-1.94 0.077,-2.064 0.159,-2.064L0.242,-2.064C0.324,-1.857 0.531,-1.651 0.696,-1.073C0.944,-0.124 1.108,1.155 0.985,1.733C0.943,1.898 0.943,1.98 0.902,2.063L0.82,2.063C0.696,2.063 0.531,1.733 0.324,1.114C0.121,0.333 -0.027,-0.672 -0.027,-1.348C-0.027,-1.493 -0.02,-1.624 -0.006,-1.733Z",
    style: {
      fill: "url(#_Linear26)",
      fillRule: "nonzero"
    }
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.25365,-6.20356,-6.19157,-2.25802,288.25,168.374)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.369,1.645C0.072,2.134 -0.072,1.764 0.011,0.879C0.095,-0.005 0.351,-1.146 0.635,-1.599C0.897,-2.1 1.053,-1.765 0.97,-0.88C0.901,-0.153 0.716,0.748 0.507,1.324C0.461,1.448 0.415,1.557 0.369,1.645Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0393812,-0.108194,-0.107985,-0.039305,4.40502,50.0763)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image28",
    x: 388.787,
    y: 177.396,
    width: "32.321px",
    height: "7.981px",
    transform: "matrix(0.979435,0,0,0.997684,0,0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1e-07,4.64064,4.63167,1e-07,503.865,222.336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.052,-1.781C0.052,-2.047 0.105,-2.154 0.211,-2.154L0.318,-2.154C0.371,-2.047 0.477,-1.728 0.637,-1.196C0.903,-0.186 1.062,1.143 1.009,1.781L1.009,2.153L0.903,2.153C0.796,2.153 0.637,1.834 0.424,1.196C0.193,0.316 0.042,-0.806 0.042,-1.502C0.042,-1.606 0.045,-1.699 0.052,-1.781Z",
    style: {
      fill: "url(#_Linear29)",
      fillRule: "nonzero"
    }
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.72091,-4.73753,-4.72836,-1.72424,502.952,227.549)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.336,1.674C0.073,2.256 -0.074,1.941 0.014,0.984C0.103,0.027 0.382,-1.173 0.63,-1.708C0.877,-2.244 1.023,-1.93 0.951,-1.018C0.875,-0.185 0.652,0.833 0.433,1.435C0.401,1.524 0.368,1.605 0.336,1.674Z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip30)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0515642,-0.141678,-0.141404,-0.0514645,2.20683,109.683)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image31",
    x: 686.315,
    y: 257.973,
    width: "26.224px",
    height: "5.98px",
    transform: "matrix(0.971262,0,0,0.996632,0,0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.99165,0,0,-3.99938,501.493,243.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -4.506,
    width: 1,
    height: 9.011,
    style: {
      fill: "url(#_Linear32)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12.3435,-3.60965e-16,3.61664e-16,-15.3206,497.606,453.467)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -1.938,
    width: 1,
    height: 15.787,
    style: {
      fill: "url(#_Linear33)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.99165,0,0,-3.99938,286.951,183.287)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -4.505,
    width: 1,
    height: 9.011,
    style: {
      fill: "url(#_Linear34)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12.3435,-2.75934e-16,2.76469e-16,-14.625,283.065,426.122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -3.9,
    width: 1,
    height: 20.652,
    style: {
      fill: "url(#_Linear35)"
    }
  })))), /*#__PURE__*/React.createElement("defs", null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "703px",
    height: "131px",
    xlinkHref: "data:image/png;base64,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"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "26px",
    height: "37px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAlCAYAAABcZvm2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAB00lEQVRIibWXS1LDMAyGf3k8zp7ejbY8NsCxgAPQF+Ve5QBNZsTCyK/YqZsm2sQjOf9nWbLTEjL2czwyABARjDEwxqBpGvdMx2J3iwXl9ABAp47vw4GZGUQEZsb5fM6+yMxubIwBEeH3dOISLAId9nsORUJYKJyzSzAH2u92DDCYPSCEtW07CGJmNE1ThGkA2G03bIUJRHUwiaWZlmB6u/liK2wB18BKloNpW3iAmSaBydwUpq1/PGyoSUKYtg1AN8GGzBgDpRS0r4+FWYth4q+B5ZrEGGNr5IXrs7FjgBlo2/biOdNydsbBfLzrumFQ3Nq4uk4lWJqha4awTlPBkozSBpgHlmzdWBh6cYHJnGTrxsLy8TCzwhXkm2IsTM6ewBSzpCeT7DP09ePxWLYo72N0XQdVFpsWpobFpoMp3xlTwfILUPElWA9LxcK5OZiSl66F5cT8Ivpxt3VTwXJ1Yk62bk5YcI7mhQXfo/j+ktNdviFqbg04n/pXrcrm+sy8jwDg8+Nd0gARgYjc2K6wPC77krgAxsEuLSAYI7A5Yb1f/XPBVAp6eX1z8PoGGW6a++WSeqCpYcvVmgD0M7oFlvpW6wenUfzPKVZfs9j3+PQcaf8BHZMrTti3QLwAAAAASUVORK5CYII="
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "_Image5",
    width: "26px",
    height: "37px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAlCAYAAABcZvm2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABN0lEQVRIibWXUW7CMAyGf/sI4y6g8TBOAIeFk3RinZhAcAE4QsxTorVNGydx/NLKlf0lf/9IMSESj/tdiAhEBGYePMc5Hx+rFcV6+eBx4na9inMOIgIRgX+fy/l4PZ+iBv1dLpJqXAoLoN++F23jEhgDwM/5LLmNc2H83XXRf2IN46VCSxinCq1grCm0gLFzblIwzqW+a2CmO1paAGublcrnc5xTWANbtLclLGlvK5jKDBYwtRlqYVlmqIENzKA9FyUHt8mOYgvItnepfEX2LoEV2zsXVmXvHFi1GbSwiXStYFHpWsCCdLUHNwVjAKY7mlt0uKm2lo8A4HQ8hvvXeGLQTBSaXBg1msP+X1tbwibDkzVsvdkQEBnE9odDgNcaxEOiICvY53Y7UGtx7ozJqJHva7eb9H0DgR2WHY0JwpYAAAAASUVORK5CYII="
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    id: "_Image7",
    width: "39px",
    height: "9px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAJCAYAAACxBTVzAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAhklEQVQ4jbXTbQqAMAgGYF+n979AddX6UcZW7rM1EIaiPgyGbV12ehwAdiO7ern2up87+/I5aYXUcF8hXo8wc/cr1IaO9MR1M7i4+RBveQMO4MKiWZA8Ll+/Xu5/yD0sqqc5ACQiaYziZkNUlUIIpKp1XA+khGNmEpH34pawDzETMhLxLDsHAv4GdWdsFqEAAAAASUVORK5CYII="
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    id: "_Image9",
    width: "39px",
    height: "10px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAKCAYAAAA3kUfdAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAi0lEQVQ4jc2TwQ2AIAxFP4QJZP8ldBUcAweAQz1BVAS0JcYmnGjh9f9Wrc6RUgq1o7Wu3j2p68VkbTXJhBDyYwBYMJyaFJv3VAM2MUYWDKeRXv4VOCs3EkKi6vHPAk4yY6PHgmWrpIk3tU1bpTDSsTAAQEQgOi/NL9RMMMs8Fyt9F5+q2QLhAI+0dgfM4C1buR0uvAAAAABJRU5ErkJggg=="
  })), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    id: "_Image11",
    width: "46px",
    height: "14px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAOCAYAAABQFS4BAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABbUlEQVRIicWWzZKDIAyAEyD00lfbPmz3iXrHk53phcQ9KIoYtLh/zDAiYvz4Eh0R/rh93u/Du2uttUBES/d+HuN/w6Ex4HO4DHIz/xPgTXCIKlh+7pU5IgJrLTDzqovwMXgLoEsAjfaIaAPHzCDMELMxMwPLeMRmOOdO2xMREBFgjsCRgUVU4BVogo0LNDMDatDGmF1Le/YAoA4h+fy0ARZ9XVzfk67Faeyu12uzPUSczC0gr9cLns/nW7YW0BQj20BaF8dajmW8ZPzxeAxegU4vRaqzOcWzrZ3UqobLddt4ImurzDxXQNkxxjhogWMKtLE1PlAU+NxWmeJqLYvAMAw6HGpz4/fEhRAWq022KimuwIokOARjLBhjwHtXAT7+SrsuhEZbWYpF5lpM10sIIoLL5aIaPGoft1t1By6EcGir7GUqrXVA5FV734Hba67rggoHsH4p0n+DVodHqT0Ltwve9/0K4mzd/QbcXvsCZvnDCBIvpsoAAAAASUVORK5CYII="
  })), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    id: "_Image13",
    width: "11px",
    height: "30px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAeCAYAAAD6t+QOAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABJElEQVQ4jY2UXW6EMAyEB9tHaHqr5bDb43AP2rXB6QM/cUjYNlIkHj6NZsYxAwB8PZ8ZAOZ5xuv1g5QSUvrER0pIKeF7njFNEwjhuDuYublqBlW9h4np/DYzmFmB3R3u6w4ymKXAqj14U5ZgYV1XmBmWZQEd4SK8XTotqBkA1MoAgo3abwPXLUiBVfswdWz8Q3nveG/ihNtwe9dEbcAuTIyc81ZbDyaqlWO4CgYyWIoqS5lcAxNRAffqYhMVzCIFlC2chnAVLJdwV8+PcRzI3ZFzsBEDXj2X2qQEZAaA1nPOoWM6Hn49uY4yNR1rD65GfDOQCyxvw11gqlYqhnuM4/DWxrH+t56P9e/V1vHcrlIXjj+VXscAQAcgf3RcwZuFdknj+QVQPziut6ocXQAAAABJRU5ErkJggg=="
  })), _image8 || (_image8 = /*#__PURE__*/React.createElement("image", {
    id: "_Image15",
    width: "20px",
    height: "30px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABfElEQVRIia2WTW7CMBCF36tGStbldMCu7bHaXqCl0IPRbVjgDAuwM/6LA+pIkeI4/jzznhlCmPg9HJQkSEJE0Pd98eq6Lqx5Xq1oGeJvDvu9qmqYOJ/POJ1OqIWH/h2PaqECAD+7naoqSMAwH4LK7vvLZEaQmkGHYQAA+PdUNVx930dQUUUCyaHOXaEWaMNCxU/G5aZQwrn58j30BiSAVMM21JbuyxfALypDAVseg6YekobE7qYAgGS0kCScc9Xy5fpuDE1NWQL18xUNS1BkmzjnsvIzDa1ereNEEuM4RplKKmzL6Ra0aMr9UGAcRwzDUDYlhy7P3GiIGeiyzAGNXb4fGgdJq+Ej0FzPpDmUoG05LDSYUofWMzfbpaa0IPlvvOb0jIZ5FkucrjTYGHrP8RFg6hR5V1kKnRIKf6M1aKTaguNEAPj8eJ8KIG9lXO/r4+lZNPagx6CFTWxJ/wJNdcqh04IWdL3Z8ikFvry+hU1KXwq+O6Xj9WZLALgAuC3RzKcCQXcAAAAASUVORK5CYII="
  })), _image9 || (_image9 = /*#__PURE__*/React.createElement("image", {
    id: "_Image17",
    width: "20px",
    height: "31px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAfCAYAAADnTu3OAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA+0lEQVRIia2WbQ6DIAyGS8MJ5lVmMjOvMA/rjuISFxd3AzyC3S8IMNDy0YSEl9InoVKpAMu+60qICHoIISCktV2aRoBnxvtZFiIi2PfdjJjWtilFQeB7nukMwoXia5rIDyyBYiwwFyp9ByIabc+PtP5Qm1Ik9UItqOQEpkCdI9eA/h25FBo8cglU5gQe+bKvDTuHpdDia8POYS70MIc50NMcpkJZOUyBskuPC00qPQ40ufTO9maV3tFeCQDFvywnh9pZC2qAtaACAOA5ju7bGukeYp2ErU0rUQtqWpHHMDh9SugN9ue+vratQBtSAr11nQCwmqUS6L3vTcwPI6qqW66/wCIAAAAASUVORK5CYII="
  })), _image10 || (_image10 = /*#__PURE__*/React.createElement("image", {
    id: "_Image19",
    width: "29px",
    height: "7px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAHCAYAAAD03kbyAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAWElEQVQokWOcN3fOfwa8gBFCMuJXRQpgYWFhIUMbqgtIdRALMzMLBb4gTiO6+QR9SryDiHc5mcGLZBVOu3A7goWFhZmgIsocg2kui4CAIFQRI1E0uXLIagDkDgOTvAN+6QAAAABJRU5ErkJggg=="
  })), _image11 || (_image11 = /*#__PURE__*/React.createElement("image", {
    id: "_Image21",
    width: "29px",
    height: "7px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAHCAYAAAD03kbyAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAaklEQVQoka2RQQ7AIAgEWeML6v8/Yf9iX2GveBF7sgdp2mjZyyQksLDgSKk55wgArfBLWwgYa76Usmz4xq4z56ZMmVk1WS7wlIpn5t/DZjkVr1UCXkSIiKjWep8PwDRWxW60x6gePsrqzxel2B8Q9yIYxAAAAABJRU5ErkJggg=="
  })), _image12 || (_image12 = /*#__PURE__*/React.createElement("image", {
    id: "_Image23",
    width: "38px",
    height: "13px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAANCAYAAADFVhxbAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABaUlEQVQ4jb2U3W7DIAxGjXFN+xJ9o/Vht7di6i6TqrVhF4Twk6ZNpXVIESQinMNnEgNval+fn3HrXCICdg4cM/B0mf8U2O124Jyb4cxchLrnm8VeEViFdwJZKIQAKgKiCqoCIroU2ypgEJvoM/De7rOoiICqzr2KgHRCqRcwz0Sstdt2P42JqMB7qAiICqhoet7c170AZQEi2hw9MwMipl1P0NvtBpfLpchM0JxChibh6b15A0UsJ0bH43EVzsxgjGlKcL1eYRiGJnoVnUpSQR5Ai3gpZ56PiIBowYzjGB0zhBir+tf17hZZK0F+7wG07hEtWJskELEbWzA/53OsF8uAZ9CmJNXZqOEhhDmBBMaFECLePdvkvZ+BedG1A7mYN41jjA2cKP2vmgTMtj/Tx+lkkti376LvP91yNgBMs/P0ERQ4Ir4ssNbIe79IIUecYcwODodDI/EX8Idi4zDMCez3+0UC7xZYa78/ixWNANYo0QAAAABJRU5ErkJggg=="
  })), _image13 || (_image13 = /*#__PURE__*/React.createElement("image", {
    id: "_Image25",
    width: "9px",
    height: "25px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAZCAYAAADjRwSLAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABFElEQVQokW2SMXIDMQwD4QNa91H+5Hus8yHnBXYrjsmkkKiTLvHMdZglFvIFAL7u9x8AeL2euF6vKKWglE98lILvxwMb+i8i4O6gND5JMDNsSXF3RARE9Y94v9+oZitJEiSCItgpVusccpAEqRG2Wtu5DLlPJAqkUM1Q/5BGYTaS2UpqpQnxIFmtiIgWOutr0gfQQoc+h753/RGKCJCEpKFfu/4U8hbIIafS07mYKBylbT3XhtQ0ZG60djoNaWaIiBZKfaV+F8jSPXTop6G7jz63fb9s7rE8LDslNxqkXFgUSC4bAcB21s/nsJUUhz7X/9FyjtNzpL67n851qzScSy/FyUaKiFH6tu8XANiGPvVvaQD4BeCW6b1EKkJnAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear26",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,-6.61744e-24,0,-1,0,-0.00044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(158,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(238,237,237)",
      stopOpacity: 1
    }
  })), _image14 || (_image14 = /*#__PURE__*/React.createElement("image", {
    id: "_Image28",
    width: "33px",
    height: "8px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAICAYAAAB3R5aRAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAkElEQVQ4jbVTwRHDIAyTDBM0+y+RTpDuk/7hsOmLu4QjDU2oX9gWZyELvpYliwhEBM45lHOd9/ZIYhuPadoXGuFjjJcG92AB4L2u+YyQDyFcfvUv2G+EvJnBzJBS+svwVl4T8ltZVBWqCpK3fNGLLf7Z7eg5zxlVkBymwlHv0LktQiNUaN09/T4tMoXQqPV8AM7YMi+QgzTCAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear29",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-0.00043)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(158,157,156)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "rgb(179,178,178)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(238,237,237)",
      stopOpacity: 1
    }
  })), _image15 || (_image15 = /*#__PURE__*/React.createElement("image", {
    id: "_Image31",
    width: "27px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAGCAYAAAAynOUQAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAeElEQVQokaWRQQ7CMAwEx8m+gP7/E+VanlTOkSI7XAA1ECHarrRSksOOvbHbsrScM2dsZmx1mab+4SmVUnYFp5TeZ0nd/QW+r2sbgRURRAS11p/BRwx0YG3XdHfcHeAUZDQkQNftdZ4bHzKzryBJhxoYfuS/4L1+AIUtJvcE+4TbAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear32",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,6e-05)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear33",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-1.176)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear34",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,0.00015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear35",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,-1,0,-0.2351)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(140,142,154)",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasvordachPfosten);
export default __webpack_public_path__ + "static/media/glasvordach_pfosten.63a60e8bb66bcf9b5314b01b3cc06e76.svg";
export { ForwardRef as ReactComponent };